import type { JSONB } from '@risksmart-app/domain/src/types/common.types';
import { z } from 'zod';

import type { OverallDashboardState } from './useDashboardStore';

const dateRangeSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('absolute'),
    startDate: z.string(),
    endDate: z.string(),
  }),
  z.object({
    type: z.literal('relative'),
    key: z.string().optional(),
    amount: z.number(),
    unit: z.enum(['second', 'minute', 'hour', 'day', 'week', 'month', 'year']),
  }),
]);

const dashboardContentSchema = z.object({
  filters: z
    .object({
      departments: z.array(z.string()),
      tags: z.array(z.string()),
      dateRange: dateRangeSchema.nullish().transform((value) => value ?? null),
    })
    .passthrough(),
  widgets: z.array(
    z
      .object({
        id: z.string(),
        widgetType: z.string(),
        rowSpan: z.number().optional(),
        columnSpan: z.number().optional(),
        columnOffset: z.record(z.number()).optional(),
        settings: z.unknown().optional(),
      })
      .passthrough()
  ),
});

export const parseDashboardContent = (
  content: JSONB | null,
  id: string
): OverallDashboardState => {
  const parsedContent = dashboardContentSchema.parse(content);

  return {
    ...parsedContent,
    id,
  };
};
